import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useMemo, useRef, useState } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { InputAdornment, Stack, TextField } from '@mui/material';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { Toaster } from 'react-hot-toast';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import ErrorDialog from '../../../components/ErrorDialog';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { GET_INSTITUCIONES } from '../../../data/graphQL/queries/Instituciones/getInstitucionesAll';
import './institucionAll.scss';
import { normalizeFilterValue } from '../../../helpers/tools';

export default function InstitucionAll({ setChildrenAction }) {

  const [datos, setDatos] = useState('');
  const [datosOriginal, setDatosOriginal] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const txtFiltro = useRef(null);

  const rutasStorage = localStorage.getItem('navigationRoutes');

  const [allowedWrite] = useState(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;

      return rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura;
    } else {
      return false;
    }
  });

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  useEffect(() => {
    getInstituciones();
  }, []);

  useEffect(() => {
    if (allowedWrite) {
      setChildrenAction(() =>
      <div>
                    <CustomButton
          onClick={handleNew}>
           Nueva
                    </CustomButton>
                </div>
      );
    }
  }, [setChildrenAction]);


  const [getInstituciones, { data: dataInstituciones, loading: institucionesLoading }] = useLazyQuery(GET_INSTITUCIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataInstituciones) return;
    if (dataInstituciones.instituciones.success) {
      const dataAll = dataInstituciones.instituciones.valorEsperado;
      setDatos(dataAll);
      setDatosOriginal(dataAll);
    };
  }, [dataInstituciones]); 

  const handleEdit = (row) => {
    navigate('/institucionAdmin/' + row.cod_Institucion, { state: { institucion: row, edit: true, opcion: 1 } });
  };

  const handleVisualizar = (row) => {
    navigate('/institucionAdmin/' + row.cod_Institucion, { state: { institucion: row, edit: false, opcion: 0 } });
  };

  const handleNew = () => {
    navigate('/institucionAdmin/0', {
      state: {
        institucion: {
          cod_Institucion: '',
          nombre: '',
          idDelegacion: 0,
          origen: '',
          origenSAP: false,
          nombreFantasia: '',
          domicilio: '',
          activo: true,
          tipoUnidad: 0,
          idLocalidad: 0,
          idProvincia: 0,
          tipoInstitucion: 0,
          localidad: '',
          provincia: '',
          listaInstituciones: datos
        }, edit: true, opcion: 2
      }
    });
  };

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const handleSearch = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtFiltro.current.value != "") {
      setDatos(datosOriginal.filter((datosOriginal) => {
        const delegacionBuscar = datosOriginal.delegacion.toUpperCase();
        const codigoBuscar = datosOriginal.cod_Institucion.toUpperCase();
        const nombreBuscar = datosOriginal.nombre.toUpperCase();
        const nombreFantasiaBuscar = datosOriginal.nombreFantasia.toUpperCase();
        const origenBuscar = datosOriginal.origen.toUpperCase();


        const inputBuscar = normalizeFilterValue(txtFiltro.current.value);
        return (
          delegacionBuscar.includes(inputBuscar) ||
          codigoBuscar.includes(inputBuscar) ||
          origenBuscar.includes(inputBuscar) ||
          nombreBuscar.includes(inputBuscar) ||
          nombreFantasiaBuscar.includes(inputBuscar));

      }
      ));
    } else {
      setDatos(datosOriginal);
    }
  };


  const handleClean = () => {
    txtFiltro.current.value = "";
    handleSearch();
    txtFiltro.current.focus();
  };

  const initialColumns = [
  {
    headerName: '',
    field: 'action',
    cellClassName: 'grid-actions-column',
    flex: 0.06,
    renderCell: ({ row }) => {
      return (
        <>
                        {allowedWrite && <div style={{ paddingTop: '6px' }}><EditIcon sx={{ width: 22, height: 22, cursor: 'pointer' }} className='edit-icon-no-margin' onClick={() => handleEdit(row)} /></div>}
                        {!allowedWrite && <div style={{ paddingTop: '6px' }}><VisibilityIcon sx={{ width: 22, height: 22, cursor: 'pointer' }} className='edit-icon-no-margin' onClick={() => handleVisualizar(row)} /></div>}
                    </>);

    }
  },
  { field: 'delegacion', headerName: 'Delegación', flex: 0.2 },
  { field: 'cod_Institucion', headerName: 'Código', headerAlign: 'left' },
  { field: 'nombre', headerName: 'Nombre', flex: 0.5 },
  { field: 'nombreFantasia', headerName: 'Nombre de Fantasia', flex: 0.5 },
  { field: 'origen', headerName: 'Origen', align: 'center', headerAlign: 'center', flex: 0.1 },
  { field: 'activo', type: 'boolean', headerName: 'Activo', align: 'center', headerAlign: 'center', flex: 0.1 }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  return (
    <>
            <Stack direction="row" spacing={1} alignItems="center">
                <TextField
          className="input-300"
          label="Filtrar"
          name="txtFiltro"
          size="small"
          type="text"
          variant="outlined"
          inputRef={txtFiltro}
          onKeyUp={handleSearch}
          sx={{ backgroundColor: 'white' }}
          InputProps={{
            endAdornment:
            <InputAdornment position="end">
                                <SearchIcon
                onClick={handleSearch}
                sx={{ cursor: 'pointer' }} />
              
                                <ClearIcon
                onClick={handleClean}
                sx={{ cursor: 'pointer' }} />
              
                            </InputAdornment>

          }} />
        
            </Stack>
            <br />
            <DataGridGenerico
        columns={columns}
        fileNameExport='Instituciones'
        rows={datos}
        toolbar={false}
        totalCount={datos.length}
        loading={institucionesLoading} />
      
            <Outlet />


            <ErrorDialog
        id="dlg-error-chgpass"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
        </>);


}